export default __webpack_public_path__ + "static/media/instructors.d4fef61f.jpg";